module.exports = __webpack_public_path__ + "static/hero-right2-aa917f6e1a8132e6a10c03d4f48da411.png";